import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'dues',
    lazy: async () => ({ Component: (await import('./DuesPage')).DuesPage }),
  },
];
